import { useMutation } from '@tanstack/vue-query';

import providerInstance from '@/services/provider';
import { IRequisitionLineData } from '@/models';

export function useUpdatePurchaseRequisitionLine() {
  const { isLoading, isError, error, isSuccess, mutate, reset } = useMutation({
    mutationKey: ['update-purchase-requisition'],
    mutationFn: ({ id, line }: { id: number; line: IRequisitionLineData }) =>
      providerInstance.requisition.updateRequisitionLine(id, line)
  });
  return {
    isLoading,
    isError,
    error,
    isSuccess,
    mutate,
    reset
  };
}
